import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatiComponent } from './plati.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        PlatiComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [PlatiComponent],
})
export class PlatiModule { }
